import { CSSProperties, useEffect, useRef, useState } from 'react';

export const useSetDefaultContainerStyle = (addNewItemButtonIsHide: boolean) => {
  const [containerStyle, setContainerStyle] = useState<CSSProperties>({});

  const buttonRef = useRef<HTMLDivElement>(null);

  const setDefaultContainerStyle = () => {
    setContainerStyle(prevState => ({
      ...prevState,
      paddingBottom: 0
    }));
  };

  useEffect(setDefaultContainerStyle, []);

  return { buttonRef, containerStyle };
};
